export default __webpack_public_path__ + "static/media/Pixel3.6f0bf399.gif";